import {http} from '@services/utils';

import {type LoginRequest, type LoginResponse, LoginResponseSchema} from './login.schema';

/**
 * POST `auth` — основной логин по email/паролю.
 *
 * Возвращает general-токен (`token`) + user. Этот токен даёт доступ к
 * `auth/permission`, но НЕ к остальному API — после логина нужно
 * выбрать контекст и обменять на scoped-token (см. `getScopedToken`).
 */
export const login = async (body: LoginRequest): Promise<LoginResponse> => {
  const raw = await http('auth', {method: 'POST', body});
  return LoginResponseSchema.parse(raw);
};
